export default __webpack_public_path__ + "static/pay-2-81d02eb250b37a4c1d0f16a091fc030a.png";